/* 🤖 this file was generated by svg-to-ts */
export const matIconPropane: {
  name: 'propane';
  data: string;
} = {
  name: 'propane',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 6h-1V5c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v1H7c-3.31 0-6 2.69-6 6s2.69 6 6 6v3h2v-3h6v3h2v-3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm-7-1h4v1h-4V5zm7 11H7c-2.21 0-4-1.79-4-4s1.79-4 4-4h10c2.21 0 4 1.79 4 4s-1.79 4-4 4z"/></svg>`
};
